<template>
  <div class="video-container" @click.once="onFirstPlay">
    <!-- Scorebat embed -->
    <div class="iframe-wrapper">
      <iframe
        src="https://www.scorebat.com/embed/v/WWY2T0YydE1MaGNBTllaN3lwR3pCWHhEWmhINDg3UU1LSUo0YzlyMUJPdz0=/?token=MjEwODZfMTc2NzE2MTg1MV8wNmE4YjIxMGVhM2VmY2Y1MGY1NzY2OWZjODQ1ZjU1MDc4MjVhNWU1&utm_source=api&utm_medium=video&utm_campaign=free-feed"
        frameborder="0"
        allow="autoplay; fullscreen"
        allowfullscreen
      ></iframe>
    </div>

    <!-- Your poster overlay -->
    <div v-if="showPoster" class="poster-overlay">
      asdasdasddaasasdasdasda
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showPoster: false,
      started: false,
    };
  },
  methods: {
    onVideoClick() {
      // Trigger only once (first play)
      if (this.started) return;
      this.started = true;

      // Show poster during Scorebat ad
      this.showPoster = true;

      // Hide after 9 seconds
      setTimeout(() => {
        this.showPoster = false;
      }, 9000);
    },
  },
};
</script>

<style scoped>
.video-box {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
}

.video-box iframe {
  width: 100%;
  height: 100%;
}

/* Poster overlay */
.poster-overlay {
  position: absolute;
  inset: 0;
  z-index: 10;
  pointer-events: none; /* 🔥 THIS makes it work */
}

.poster-overlay img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

</style>